import React from "react";
import { useTranslation } from "react-i18next";
import TrashIcon from "../../../assets/icons/Trash.svg";
import * as moment from "moment";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { playSong } from "../../common/actions/common.actions";
import { IoIosFootball } from "react-icons/io";

const Content = ({
  eventTime,
  homeTeam,
  awayTeam,
  bodyHandicap,
  goalHandicap,
  match,
  sendDataToParent,
  selectedMatches = [],
  fromSelectedPage = false,
  handleRemoveCard,
  isFivePercent,
  flag,
}) => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const location = useLocation();

  const handleSongClick = async () => {
    dispatch(playSong());
  };

  const handleClick = (choosen) => {
    handleSongClick();
    sendDataToParent(choosen, match);
  };

  const isSelected = selectedMatches?.some((x) => x.eventId === match.eventId);

  const isHomeChosen =
    isSelected &&
    selectedMatches?.some(
      (x) => x.eventId === match.eventId && x.choosen === "home"
    );

  const isAwayChosen =
    isSelected &&
    selectedMatches?.some(
      (x) => x.eventId === match.eventId && x.choosen === "away"
    );

  const isOverChosen =
    isSelected &&
    selectedMatches?.some(
      (x) => x.eventId === match.eventId && x.choosen === "over"
    );

  const isUnderChosen =
    isSelected &&
    selectedMatches?.some(
      (x) => x.eventId === match.eventId && x.choosen === "under"
    );

  const removeCard = async () => {
    await handleSongClick();
    handleRemoveCard(match.rapidEventId);
  };

  return (
    <li className="w-full max-w-2xl mx-auto mb-1 font-myanmarSansPro ">
      {/* Header */}
      {/* <div className="flex justify-between items-center mb-1">
        {fromSelectedPage ? (
          <img
            src={TrashIcon}
            alt="Remove"
            onClick={removeCard}
            className="w-4 h-4 cursor-pointer opacity-70 hover:opacity-100 transition"
          />
        ) : (
          <div
            className={`${
              flag === match.leagueName ? "hidden" : "flex"
            } items-center gap-2 px-3 py-1 rounded-full border border-blue-300 bg-blue-50 text-blue-900 text-xs font-semibold`}
          >
            <IoIosFootball size={16} />
            <span>{match.leagueName}</span>
          </div>
        )}
      </div> */}

      {/* Card */}
      <div
        className={`border-y border-[#218F6B]/60 shadow-md px-4 py-2 transition duration-200 ${
          location.pathname === "/body"
            ? isFivePercent
              ? "bg-[#072E25]/90"
              : "bg-[#072E25]/10"
            : "bg-[#072E25]/10"
        }`}
      >
        {/* Date/Time */}
        <div className="flex justify-between mb-1 items-center ">
          <div className="flex items-center  text-wback text-xs font-semibold">
            <IoIosFootball size={16} />
            <span>{match.leagueName}</span>
          </div>
          <p className="text-xs md:text-sm text-center text-wback dark:text-white font-semibold ">
            {moment(new Date(match?.eventTime)).format("DD.MM.YYYY h:mm A")}
          </p>
        </div>

        {/* Home & Away */}
        <div
          className={`grid grid-cols-2 gap-1 mb-1 ${
            fromSelectedPage ? "pointer-events-none opacity-80" : ""
          }`}
        >
          {/* Home */}
          <div
            onClick={() => handleClick("home")}
            className={`p-3 rounded-lg flex justify-between items-center cursor-pointer transition-all ${
              isHomeChosen
                ? "border border-white/30 bg-focusColor text-white"
                : "border border-white/30"
            }`}
          >
            <span className="text-sm font-semibold text-center text-wback flex-1">
              {i18n.language === "en" ? match.homeTeam : match.homeTeamMyan}
            </span>
            {match.overId === match.homeId && (
              <span className="text-xs font-bold px-2 py-1 bg-blue-100 text-blue-950 rounded-full ml-2">
                {match.bodyHandicap}
              </span>
            )}
          </div>

          {/* Away */}
          <div
            onClick={() => handleClick("away")}
            className={`p-3 rounded-lg flex justify-between items-center cursor-pointer transition-all ${
              isAwayChosen
                ? "border border-white/30 bg-focusColor text-white"
                : "border border-white/30"
            }`}
          >
            {match.overId === match.awayId && (
              <span className="text-xs font-bold px-2 py-1 bg-blue-100 text-blue-950 rounded-full mr-2">
                {match.bodyHandicap}
              </span>
            )}
            <span className="text-sm font-semibold text-center text-wback flex-1">
              {i18n.language === "en" ? match.awayTeam : match.awayTeamMyan}
            </span>
          </div>
        </div>

        {/* Over / Odds / Under */}
        <div
          className={`grid grid-cols-5 gap-1 ${
            fromSelectedPage ? "pointer-events-none opacity-80" : ""
          }`}
        >
          {/* Over */}
          <div
            onClick={() => handleClick("over")}
            className={`col-span-2 p-2 text-center rounded-lg cursor-pointer transition-all ${
              isOverChosen
                ? "bg-focusColor text-white"
                : "border border-white/30"
            }`}
          >
            <span className="text-sm font-semibold text-wback">
              {t("goalOver")}
            </span>
          </div>

          {/* Odds */}
          <div className="p-2 bg-white text-sm font-bold font-mono rounded-lg flex items-center justify-center">
            {match.goalHandicap}
          </div>

          {/* Under */}
          <div
            onClick={() => handleClick("under")}
            className={`col-span-2 p-2 text-center rounded-lg cursor-pointer transition-all ${
              isUnderChosen
                ? "bg-focusColor text-white"
                : "border border-white/30"
            }`}
          >
            <span className="text-sm font-semibold text-wback">
              {t("goalUnder")}
            </span>
          </div>
        </div>
      </div>
    </li>
  );
};

export default Content;
